import { ActionMap } from '@/store/store.interface';

import { PageModelsPayloadType, PageModelsActions, PageModelsType } from './pageModels.interface';

export type PageModelsActionsType =
  ActionMap<PageModelsPayloadType>[keyof ActionMap<PageModelsPayloadType>];

export const PageModelsReducer = (state: PageModelsType, action: PageModelsActionsType) => {
  switch (action.type) {
    case PageModelsActions.Update:
      return {
        config: {
          ...state.config,
          ...action.payload.config,
        },
        labels: {
          ...state.labels,
          ...action.payload.labels,
        },
        taxonomy: action.payload.taxonomy,
        esCustomLabels: action.payload.esCustomLabels,
        esLabels: action.payload.esLabels,
        httpStatusCode: action.payload.httpStatusCode,
        language: action.payload.language,
        langToRedirect: action.payload.langToRedirect,
        ready: true,
      };
    default:
      return state;
  }
};
